import { usePathname } from 'next/navigation';
import { extractPath } from '@sitecore-content-sdk/nextjs/utils';
import { GetStaticPropsContext } from 'next';

/**
 * The path name on the server includes our rewritten path, which is different from on the client
 * This causes a hydration error.  Use `extractPath` to get the real path.
 * @returns
 */
export function useRealPathName() {
  const pathName = usePathname();
  const path = extractPath({
    params: { path: pathName ?? '' },
  } as GetStaticPropsContext);
  return path;
}
